import { filter, map, take } from 'rxjs/operators';
import { WebSocketService } from './../services/web-socket.service';
import { Component, Output, EventEmitter, OnInit, AfterViewInit, Pipe } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { LayoutService } from '../services/layout.service';
import { ConfigService } from '../services/config.service';
import { Router } from '@angular/router';
import { AuthService } from '../services/comman/auth.service';

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"]
})
export class NavbarComponent implements OnInit, AfterViewInit {
  typeOfOrganization = sessionStorage.getItem('typeOfOrganization');
  actAs = sessionStorage.getItem('actAs');
  currentLang = "en";
  toggleClass = "ft-maximize";
  placement = "bottom-right";
  public isCollapsed = true;
  formGroup: FormGroup;
  @Output()
  toggleHideSidebar = new EventEmitter<Object>();

  public config: any = {};
  name : any;
  role : any;
  organizationName : any
  notifications:any=[];
  constructor(private auth:AuthService ,public translate: TranslateService, private layoutService: LayoutService, private configService: ConfigService, private router: Router,private WSservice:WebSocketService) {
    const browserLang: string = translate.getBrowserLang();
    translate.use(browserLang.match(/en|es|pt|de/) ? browserLang : "en");
// this.WSservice.listen("update").subscribe(res=>{
//   console.log(res)
//   if(res["success"]){
   
    
//     this.getallnotification()
//   }
// }
// )
// this.WSservice.listenAdmin("update").subscribe(res=>{
//   console.log(res)
//   if(res["success"]){
   
    
//     this.getallnotification()
//   }
// }
// )
// this.WSservice.listenUser("update").subscribe(res=>{
//   console.log(res)
//   if(res["success"]){
   
    
//     this.getallnotification()
//   }
// }
// )

  }
  getallnotificationstart(){
  this.auth.getAllNotification().subscribe(res=>{
    console.log(res)
    if(sessionStorage.getItem('role')=="Admin"){

      this.notifications=res["data"]["create"].filter(x=>x.role != "Admin")
    }else{
      this.notifications=res["data"]["create"].filter(x=>{
if(x.UserId==sessionStorage.getItem("userId"))
{
  return x
}
    
      })
    }
  })
}
getallnotification(){
  this.auth.getAllNotification().subscribe(res=>{
    console.log(res)
    if(sessionStorage.getItem('role')=="Admin"){

      this.notifications=res["data"]["create"].filter(x=>x.role != "Admin")
    }else{
      this.notifications=res["data"]["create"].filter(x=>{
if(x.UserId==sessionStorage.getItem("userId"))
{
  return x
}
    
      })

    }
    if(this.notifications.length!=0){

      this.auth.infoSuccess( this.notifications[0]?.text)
    }
  })
}
  ngOnInit() {
    this.config = this.configService.templateConf;
    this.name = sessionStorage.name
    this.role = sessionStorage.role
    this.organizationName = sessionStorage.organizationName
    // this.getallnotificationstart()
  }

  logout() {
    sessionStorage.removeItem('token');
    sessionStorage.clear();
    
    this.router.navigate(['/Select']);
    // window.location.reload();
    // this.token = null;
  }


  ngAfterViewInit() {
    if (this.config.layout.dir) {
      const dir = this.config.layout.dir;
      if (dir === "rtl") {
        this.placement = "bottom-left";
      } else if (dir === "ltr") {
        this.placement = "bottom-right";
      }
    }
  }


  ChangeLanguage(language: string) {
    this.translate.use(language);
  }

  ToggleClass() {
    if (this.toggleClass === "ft-maximize") {
      this.toggleClass = "ft-minimize";
    } else {
      this.toggleClass = "ft-maximize";
    }
  }

  toggleNotificationSidebar() {
    this.layoutService.emitChange(true);
  }

  toggleSidebar() {
    
    this.configService.templateConf.layout.sidebar.collapsed = false;
    const appSidebar = document.getElementsByClassName("app-sidebar")[0];
    if (appSidebar.classList.contains("hide-sidebar")) {
      // this.config.layout.sidebar.collapsed = false;
     
      this.layoutService.toggleSidebarSmallScreen(true);
      
    
    
    } else {
      this.toggleHideSidebar.emit(true);
     
      
    }
  }
}